// English + Bengali translations for EMI SHAKTI
export const translations = {
  en: {
    appName: "EMI SHAKTI",
    appTagline: "Loan Management & EMI Reminder System",
    appSlogan: "Track Every Loan. Empower Every Woman.",
    appOrg: "For Sarbajaya CLF",
    appOrgFull: "Sarbajaya Cluster Level Federation (CLF)",
    appDeveloper: "Developed by Business Barao",
    appSubtitle: "For Sarbajaya Cluster Level Federation (CLF)",
    sampleDataBanner: "Demonstration Mode — All figures below are SAMPLE DATA, not real financial records.",
    sampleBadge: "Sample Data",

    // Nav
    nav: {
      dashboard: "Dashboard",
      clfs: "CLFs",
      vos: "VOs (Village Orgs)",
      shgs: "SHGs (Self Help Groups)",
      members: "Members",
      loans: "Loans",
      repayments: "Repayments",
      reports: "Reports",
      whatsapp: "WhatsApp Reminders",
      settings: "Settings",
    },

    // Login
    login: {
      welcome: "Welcome back",
      subtitle: "Sign in to continue to the CLF portal",
      email: "Email or Staff ID",
      password: "Password",
      remember: "Remember this device",
      forgot: "Forgot password?",
      signIn: "Sign in",
      disclaimer: "This is a Phase 1 preview. Authentication is not yet secure — do not enter real credentials.",
      demoLogin: "Continue as Demo Staff",
      poweredBy: "Developed by Business Barao",
    },

    // KPI cards
    kpi: {
      totalClfs: "Total CLFs",
      totalClfsSub: "Across Gomati & Sepahijala",
      totalVos: "Total VOs",
      totalVosSub: "Village Organizations",
      totalShgs: "Total SHGs",
      totalShgsSub: "Self Help Groups",
      activeLoans: "Active Loans",
      activeLoansSub: "Micro-finance disbursement",
      totalDisbursed: "Total Disbursed",
      totalDisbursedSub: "Cumulative disbursement",
      totalCollected: "Total Collected",
      totalCollectedSub: "94.2% on-time recovery",
      outstanding: "Outstanding Balance",
      outstandingSub: "Principal pending recovery",
      overdue: "Overdue Amount",
      overdueSub: "68 loans (>30 days overdue)",
    },

    // Common
    common: {
      search: "Search…",
      filter: "Filter",
      export: "Export",
      viewAll: "View all",
      actions: "Actions",
      status: "Status",
      amount: "Amount",
      date: "Date",
      name: "Name",
      id: "ID",
      district: "District",
      block: "Block",
      village: "Village",
      members: "Members",
      noData: "No records to display",
      comingSoon: "Coming in Phase 2",
      logout: "Sign out",
      profile: "Profile",
      language: "Language",
      role: "Senior Bookkeeper",
    },

    dashboard: {
      welcomeTitle: "EMI SHAKTI Dashboard",
      welcomeSub: "Track Every Loan. Empower Every Woman. · For Sarbajaya CLF",
      recentLoans: "Recently disbursed loans",
      upcomingEmis: "Upcoming EMIs this week",
      recoveryTrend: "Monthly recovery trend",
    },

    reports: {
      title: "Reports",
      sub: "Generate operational reports (preview only in Phase 1).",
    },
    whatsapp: {
      title: "WhatsApp Reminders",
      sub: "Draft reminder templates — live WhatsApp messaging will arrive in Phase 2.",
      disabled: "Sending is disabled in Phase 1.",
    },
    settings: {
      title: "Settings",
      sub: "Preferences for your account & this workspace.",
      langLabel: "Interface Language",
      themeLabel: "Appearance",
    },
  },
  bn: {
    appName: "EMI SHAKTI",
    appTagline: "Loan Management & EMI Reminder System",
    appSlogan: "Track Every Loan. Empower Every Woman.",
    appOrg: "For Sarbajaya CLF",
    appOrgFull: "Sarbajaya Cluster Level Federation (CLF)",
    appDeveloper: "Developed by Business Barao",
    appSubtitle: "For Sarbajaya Cluster Level Federation (CLF)",
    sampleDataBanner: "ডেমো মোড — নীচের সমস্ত সংখ্যা নমুনা তথ্য, প্রকৃত আর্থিক রেকর্ড নয়।",
    sampleBadge: "নমুনা তথ্য",

    nav: {
      dashboard: "ড্যাশবোর্ড",
      clfs: "সিএলএফ",
      vos: "গ্রাম সংগঠন (VO)",
      shgs: "স্বনির্ভর দল (SHG)",
      members: "সদস্যগণ",
      loans: "ঋণ",
      repayments: "ঋণ পরিশোধ",
      reports: "রিপোর্ট",
      whatsapp: "হোয়াটসঅ্যাপ রিমাইন্ডার",
      settings: "সেটিংস",
    },

    login: {
      welcome: "স্বাগতম",
      subtitle: "সিএলএফ পোর্টালে প্রবেশ করতে সাইন ইন করুন",
      email: "ইমেল বা স্টাফ আইডি",
      password: "পাসওয়ার্ড",
      remember: "এই ডিভাইস মনে রাখুন",
      forgot: "পাসওয়ার্ড ভুলে গেছেন?",
      signIn: "সাইন ইন",
      disclaimer: "এটি ফেজ ১ প্রিভিউ। অথেনটিকেশন এখনো নিরাপদ নয় — প্রকৃত তথ্য দেবেন না।",
      demoLogin: "ডেমো স্টাফ হিসেবে চালিয়ে যান",
      poweredBy: "Developed by Business Barao",
    },

    kpi: {
      totalClfs: "মোট সিএলএফ",
      totalClfsSub: "গোমতী ও সিপাহীজলা জেলা",
      totalVos: "মোট গ্রাম সংগঠন",
      totalVosSub: "ভিলেজ অর্গানাইজেশন",
      totalShgs: "মোট স্বনির্ভর দল",
      totalShgsSub: "নারী স্বনির্ভর দল",
      activeLoans: "সক্রিয় ঋণ",
      activeLoansSub: "ক্ষুদ্র ঋণ বিতরণ",
      totalDisbursed: "মোট বিতরণ",
      totalDisbursedSub: "ক্রমবর্ধমান বিতরণ",
      totalCollected: "মোট আদায়",
      totalCollectedSub: "৯৪.২% সময়মতো আদায়",
      outstanding: "বকেয়া মূলধন",
      outstandingSub: "আদায়যোগ্য অবশিষ্ট",
      overdue: "খেলাপি ঋণ",
      overdueSub: "৬৮টি ঋণ (৩০+ দিন বিলম্বিত)",
    },

    common: {
      search: "খুঁজুন…",
      filter: "ফিল্টার",
      export: "এক্সপোর্ট",
      viewAll: "সব দেখুন",
      actions: "অ্যাকশন",
      status: "অবস্থা",
      amount: "পরিমাণ",
      date: "তারিখ",
      name: "নাম",
      id: "আইডি",
      district: "জেলা",
      block: "ব্লক",
      village: "গ্রাম",
      members: "সদস্য",
      noData: "প্রদর্শনের জন্য কোনো রেকর্ড নেই",
      comingSoon: "ফেজ ২-এ আসছে",
      logout: "সাইন আউট",
      profile: "প্রোফাইল",
      language: "ভাষা",
      role: "সিনিয়র বুককিপার",
    },

    dashboard: {
      welcomeTitle: "EMI SHAKTI ড্যাশবোর্ড",
      welcomeSub: "Track Every Loan. Empower Every Woman. · For Sarbajaya CLF",
      recentLoans: "সম্প্রতি বিতরণকৃত ঋণ",
      upcomingEmis: "এই সপ্তাহের আসন্ন ইএমআই",
      recoveryTrend: "মাসিক আদায় প্রবণতা",
    },

    reports: {
      title: "রিপোর্ট",
      sub: "অপারেশনাল রিপোর্ট তৈরি করুন (ফেজ ১-এ শুধু প্রিভিউ)।",
    },
    whatsapp: {
      title: "হোয়াটসঅ্যাপ রিমাইন্ডার",
      sub: "রিমাইন্ডার টেমপ্লেট খসড়া করুন — লাইভ মেসেজিং ফেজ ২-এ আসবে।",
      disabled: "ফেজ ১-এ পাঠানো নিষ্ক্রিয়।",
    },
    settings: {
      title: "সেটিংস",
      sub: "আপনার অ্যাকাউন্ট ও এই ওয়ার্কস্পেসের পছন্দসই।",
      langLabel: "ইন্টারফেস ভাষা",
      themeLabel: "চেহারা",
    },
  },
};
